module.exports = __webpack_public_path__ + "static/media/camera_b.4c46f8bb.svg";